import { sendAction } from '../core/action.js';

function coachCompleteAccount() {
    return sendAction({
        actionId: 'ModalCoachWindowCompleteAccount',
    });
}

export { coachCompleteAccount };
//# sourceMappingURL=coachCompleteAccount.js.map
